import React from 'react';
import classes from './GalleryIcon.module.css';

/* eslint-disable max-len */

const galleryIcon = (props) => {
  return (
    <svg className={[classes.OuterSVG, classes.type].join(' ')} xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
      <path
        fill={props.fillColor ? props.fillColor : '#d2d5d6'}
        id="prefix__Path_1646"
        d="M21.75 3H2.25a2.17 2.17 0 0 0-1.594.656A2.17 2.17 0 0 0 0 5.25v13.5a2.17 2.17 0 0 0 .656 1.594A2.17 2.17 0 0 0 2.25 21h19.5A2.241 2.241 0 0 0 24 18.75V5.25A2.241 2.241 0 0 0 21.75 3zm.75 15.75a.722.722 0 0 1-.75.75H2.25a.722.722 0 0 1-.75-.75V5.25a.722.722 0 0 1 .75-.75h19.5a.722.722 0 0 1 .75.75zM5.25 10.875A2.526 2.526 0 0 0 7.1 10.1a2.6 2.6 0 0 0 0-3.7 2.526 2.526 0 0 0-1.85-.775A2.526 2.526 0 0 0 3.4 6.4a2.6 2.6 0 0 0 0 3.7 2.526 2.526 0 0 0 1.85.775zm0-3.75a1.125 1.125 0 1 1-.8 1.922 1.125 1.125 0 0 1 .8-1.922zm9.7 1.078l-4.45 4.453L9.047 11.2a1.132 1.132 0 0 0-1.594 0l-4.125 4.128a1.085 1.085 0 0 0-.328.8v1.313a.56.56 0 0 0 .563.559h16.875a.56.56 0 0 0 .562-.562v-4.313a1.085 1.085 0 0 0-.328-.8L16.547 8.2a1.132 1.132 0 0 0-1.594 0zM19.5 16.5h-15v-.234l3.75-3.75 2.25 2.25 5.25-5.25 3.75 3.75z"
        data-name="Path 1646"
        transform="translate(0 -3)"
      />
    </svg>
  );
};

export default galleryIcon;
